<form
  class="m-auto flex max-w-[500px] flex-1 flex-col md:gap-10"
  [formGroup]="transportFormService.transportForm"
>
  <div class="flex flex-col gap-4">
    <h2 class="text-center text-primary-900">
      {{ "prestation.transportStep3.title" | transloco }}
    </h2>
    <p class="text-center text-paragraph-s-reg">
      {{ "prestation.transportStep3.description" | transloco }}
    </p>
  </div>
  <section class="flex flex-col items-start">
    <label for="title" class="text-paragraph-xs-med text-greyscale-700">
      {{ "prestation.transportTitle.label" | transloco
      }}<span class="text-greyscale-500">({{ "optional" | transloco }})</span>
    </label>
    <input
      pInputText
      id="title"
      formControlName="title"
      [fluid]="true"
      [placeholder]="'prestation.transportTitle.placeholder' | transloco"
    />
    <app-error [control]="transportFormService.transportForm.get('title')!" />
  </section>

  @if (transportFormService.transportCategory() === "cruise") {
    <app-cruise-form />
  } @else if (transportFormService.calculationMode() === "airport") {
    <app-airport-form />
  } @else if (transportFormService.calculationMode() === "tim") {
    <app-tim-form />
  } @else if (transportFormService.calculationMode() === "address") {
    <app-address-form />
  } @else if (transportFormService.calculationMode() === "duration") {
    <app-transport-duration-form />
  } @else if (transportFormService.calculationMode() === "distance") {
    <app-distance-form />
  }

  @if (transportFormService.allowReturnOption) {
    <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex flex-col gap-2">
        <h4 class="text-primary-900">
          {{ "prestation.return.title" | transloco }}
        </h4>
      </div>
      <div>
        <p-selectbutton
          [options]="[
            {
              label: ('calculator.oneWay' | transloco),
              value: false,
            },
            {
              label: 'calculator.return' | transloco,
              value: true,
            },
          ]"
          formControlName="return"
        />
      </div>
      <app-error
        [control]="transportFormService.transportForm.get('return')!"
      />
    </section>
  }

  @if (transportFormService.displayVehicle) {
    <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex flex-col">
        <h4 class="text-primary-900">
          {{ "prestation.vehicle.title" | transloco }}
        </h4>
        <p class="text-paragraph-xs-reg">
          {{ "prestation.vehicle.description" | transloco }}
        </p>
      </div>
      <div class="flex flex-col items-start">
        <label for="vehicle" class="text-paragraph-xs-med text-greyscale-700">
          {{ "calculator.placeholder.vehicle" | transloco }}
        </label>
        <p-inputNumber id="vehicle" formControlName="vehicle" [fluid]="true" />
        <app-error
          [control]="transportFormService.transportForm.get('vehicle')!"
        />
      </div>
    </section>
  }
  @if (transportFormService.displayPassengerPerVehicle) {
    <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex flex-col gap-2">
        <h4 class="text-primary-900">
          {{ "prestation.passengerPerVehicle.title" | transloco }}
        </h4>
      </div>
      <div class="flex flex-col items-start">
        <label
          for="passengerPerVehicle"
          class="text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.placeholder.passengerPerVehicle" | transloco }}
        </label>
        <p-inputNumber
          id="passengerPerVehicle"
          formControlName="passengerPerVehicle"
          [fluid]="true"
        />
        <app-error
          [control]="
            transportFormService.transportForm.get('passengerPerVehicle')!
          "
        />
      </div>
    </section>
  }
  @if (transportFormService.displayPrivateVehicle) {
    <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex gap-2">
        <h4 class="text-primary-900">
          {{ "prestation.privateVehicle.title" | transloco }}
        </h4>
        <app-tooltip-icon
          position="right"
          [message]="
            'prestation.privateVehicle.tooltip'
              | transloco: { maxPassengers: MAX_PASSENGERS_FOR_PRIVATE_BUS }
          "
        />
      </div>
      <div class="flex flex-col gap-4 md:flex-row">
        <div class="flex flex-1 items-center">
          <p-checkbox
            formControlName="isPrivate"
            [binary]="true"
            id="isPrivate"
            class="mr-2"
          />
          <label
            for="passengerPerVehicle"
            class="text-paragraph-xs-med text-greyscale-700"
          >
            {{ "calculator.isPrivate" | transloco }}
          </label>
        </div>
        @if (transportFormService.isPrivate) {
          <div class="my-auto flex flex-1 flex-col">
            <label
              for="numberOfVehicle"
              class="text-paragraph-xs-med text-primary-700"
              >{{ "calculator.placeholder.numberOfVehicle" | transloco }}
            </label>
            <p-inputNumber
              id="numberOfVehicle"
              formControlName="numberOfVehicle"
              [min]="1"
              [showButtons]="true"
              [fluid]="true"
            />
          </div>
        }
      </div>
      @if (transportFormService.isPrivate) {
        @if (displayPrivateBusWarning) {
          <div class="p-1 text-paragraph-xs-reg text-warning-700">
            {{
              "prestation.privateVehicle.warning"
                | transloco: { maxPassengers: MAX_PASSENGERS_FOR_PRIVATE_BUS }
            }}
          </div>
        }
        <app-error [control]="numberOfVehicleControl" />
      }
    </section>
  }

  <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
    <div class="flex flex-col gap-2">
      <h4 class="text-primary-900">
        {{ "prestation.isMainTransport.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg">
        {{ "prestation.isMainTransport.description" | transloco }}
      </p>
    </div>
    <div class="flex flex-col gap-4 md:flex-row">
      <div class="flex flex-1 items-center">
        <p-checkbox
          formControlName="isMainTransport"
          [binary]="true"
          id="isMainTransport"
          class="mr-2"
        />
        <label
          for="isMainTransport"
          class="text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.isMainTransport" | transloco }}
        </label>
      </div>
    </div>
  </section>
  <section class="flex flex-col gap-4 rounded-lg bg-primary-50 p-4">
    <div class="flex flex-col gap-2">
      <h4 class="text-primary-900">
        {{ "prestation.scheduledDays.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg">
        {{ "prestation.scheduledDays.description" | transloco }}
      </p>
    </div>
    <app-scheduled-days-selector
      [formGroup]="transportFormService.transportForm"
    />
  </section>
</form>
